export const featureCardWrapper = {
  padding: "1.875rem",
  border: ".063rem solid #E4E4E7",
  borderRadius: ".938rem",
  ":hover": {
    transform: "scale(1.05)",
    border: ".2rem solid #E4E4E7",
    transition: ".3s",
  },
  cursor: "pointer",
};

export const featureCardTitle = {
  fontSize: "1.125rem",
  fontWeight: 700,
  lineHeight: "1.5rem",
  margin: "1.875rem 0 .938rem",
};

export const featureCardContent = { lineHeight: "1.625rem" };
